import React from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { Button } from 'transfix-ui/components/Button'
import SuggestLocation, { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import { ILoadBoardPostState } from 'types/loadBoardPosts'
import { datEquipmentTypes, DAT_EQUIPMENT_TYPES } from 'apps/booking/constants/loadBoardPosts'
import { Checkbox } from 'components/forms'

interface IActivePostFieldProps {
  activePost: ILoadBoardPostState
  setOrigin: (e: ILocationSuggestion) => void
  setDestination: (e: ILocationSuggestion) => void
  setEquipment: (e: ISelectOption<DAT_EQUIPMENT_TYPES>) => void
  setListRate: () => void
  buttonAction: () => void
  index?: number
  showAdd?: boolean
  showDelete?: boolean
  validationErrors?: {
    originError: string
    destinationError: string
  }
}

export const ActivePostField = (props: IActivePostFieldProps) => {
  const {
    activePost,
    buttonAction,
    index,
    setDestination,
    setEquipment,
    setListRate,
    setOrigin,
    showAdd,
    showDelete,
    validationErrors,
  } = props
  const isActivePostEntry = index !== undefined ? Number.isInteger(index) && index >= 0 : false

  return (
    <div className='row flex-l' data-test='active-post-field'>
      <div className='col-xs-3' data-test={`origin-city-container${index}`}>
        <SuggestLocation
          label={isActivePostEntry ? undefined : 'Origin City'}
          id='origin-city'
          placeholder='Origin City'
          value={activePost.origin}
          onChange={setOrigin}
          resultTypes={['City', 'PostalCode']}
          dataTest={`origin-city${index}`}
          errorMessage={validationErrors?.originError || ''}
        />
      </div>
      <div className='col-xs-3' data-test={`destination-city-container${index}`}>
        <SuggestLocation
          label={isActivePostEntry ? undefined : 'Destination City'}
          id='destination-city'
          placeholder='Destination City'
          value={activePost.destination}
          onChange={setDestination}
          resultTypes={['City', 'PostalCode']}
          dataTest={`destination-city${index}`}
          errorMessage={validationErrors?.destinationError || ''}
        />
      </div>
      <div className='col-xs-2'>
        <Select
          label={isActivePostEntry ? undefined : 'Equipment Type'}
          options={datEquipmentTypes}
          value={activePost.equipmentType}
          onChange={setEquipment}
          dataTest={`dat-equipment-types${index}`}
        />
      </div>
      <div className='col-xs-2'>
        <div className={`flex pt1 ${isActivePostEntry ? '' : 'mt4'}`}>
          <Checkbox
            id={`includeListRate${index}`}
            dataTest={`include-list-rate-toggle${index}`}
            label='Include List Rate'
            checked={Boolean(activePost.includeListRate)}
            onChange={setListRate}
          />
        </div>
      </div>
      {showDelete && (
        <div className='col-xs-2'>
          <div className='flex fr'>
            <Button
              color='tertiary'
              onClick={buttonAction}
              data-test={`delete-post-button${index}`}>
              Delete Post
            </Button>
          </div>
        </div>
      )}
      {showAdd && (
        <div className='col-xs-2'>
          <div className='flex mt4 pt1 fr'>
            <Button color='secondary' onClick={buttonAction} data-test='add-post-button'>
              Add Post
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
